import { render, staticRenderFns } from "./folderPermissionDialog.vue?vue&type=template&id=e826da38&scoped=true"
import script from "./folderPermissionDialog.vue?vue&type=script&lang=js"
export * from "./folderPermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./folderPermissionDialog.vue?vue&type=style&index=0&id=e826da38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e826da38",
  null
  
)

export default component.exports